jQuery(document).ready(function ($) {
  $(".elc__nuovi-arrivi__slider").slick({
    dots: true,
    arrows: false,
    slidesToShow: 4,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2,
          dots: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  });
});
